var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择承运方"},on:{"change":_vm.handleCompanySelect},model:{value:(_vm.curValue),callback:function ($$v) {_vm.curValue=$$v},expression:"curValue"}},_vm._l((_vm.List),function(item){return _c('el-option',{key:item.Id,attrs:{"label":item.CarrierName,"value":item.Id}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }